import React, { useEffect } from "react";
import Router, { useRouter } from "next/router";
import SearchForm from "shared/SearchForm";
import { SearchFormWrap, Title } from "./styled";
import { useSelector, useDispatch } from "react-redux";
import { getSearchValue, setSearchValue } from "store/searchReducer";

const Search = () => {
  const searchValue = useSelector(getSearchValue);

  const dispatch = useDispatch();

  const router = useRouter();

  useEffect(() => {
    const text = router.query.text || "";
    dispatch(setSearchValue(text));

    return () => dispatch(setSearchValue(""));
  }, [router.query.text]);

  const setInputValue = (value) => {
    dispatch(setSearchValue(value));
  };

  const onSearchClick = () => {
    Router.push(
      {
        pathname: "/search",
        query: !!searchValue ? { text: searchValue } : {}, // eslint-disable-line
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <>
      <SearchFormWrap>
        <Title>Results for:</Title>
        <SearchForm value={searchValue} placeholder="Search" onChange={setInputValue} onClick={onSearchClick} />
      </SearchFormWrap>
    </>
  );
};

export default Search;
